import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "./common/Layout";
import Back from "./common/Back";
import Loader from "./common/Loader";
import { useApi } from "../store/hooks";
import { GoToTheNextStep } from "./Step";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isEmpty } from "../utils/utils";

const DONE_STATUSES = ["Done"];

const SepaMandate = () => {
  const { t } = useTranslation();
  const { getSepaMandate, createSepaMandate, getWorkflow } = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [signatureLink, setSignatureLink] = useState("");
  const [showError, setShowError] = useState(false);

  const createAndShowSignature = async () => {
    try {
      const response = await createSepaMandate();
      setSignatureLink(response?.signatureLink);
      setIsLoading(false);
      setShowError(false);
    } catch (error) {
      if (error?.response.httpStatusCode === 422) {
        GoToTheNextStep(navigate, dispatch, getWorkflow);
      } else {
        setShowError(true);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        const response = await getSepaMandate();
        const status = response?.status;
        if (DONE_STATUSES.includes(status)) {
          GoToTheNextStep(navigate, dispatch, getWorkflow);
        } else {
          if (response?.signatureLink) {
            setSignatureLink(response.signatureLink);
            setIsLoading(false);
          } else {
            await createAndShowSignature();
          }
        }
      } catch (error) {
        setIsLoading(false);
        setShowError(true);
      }
    };
    init();
  }, []);

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data?.type !== "SEPA_MANDATE_DONE") return;
      const action = event.data?.action;
      if (action === "SUCCESS") {
        GoToTheNextStep(navigate, dispatch, getWorkflow);
      } else if (action === "RETRY") {
        setShowError(true);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const renderContent = () => {
    if (showError || (!isLoading && isEmpty(signatureLink))) {
      return (
        <>
          <div className="id-check-failure-container">
            <div className="result-header">
              <div className="mb-3">
                <img
                  src={process.env.PUBLIC_URL + "/images/error-cross.svg"}
                  alt="Error Cross Icon"
                  className="result-icon"
                />
              </div>
            </div>
            <span className="text-danger mb-4">
              {t("sepaMandate.sign.error")}
              <br />
              {t("sepaMandate.sign.error.subMessage")}
            </span>
            <span>
              <img
                src={process.env.PUBLIC_URL + "/images/reload.svg"}
                alt="Error Cross Icon"
              />
              <button className="btn btn-link" onClick={createAndShowSignature}>
                {t("global.retry")}
              </button>
            </span>
          </div>
          <Back message={t("back.label")} />
        </>
      );
    }

    return (
      <>
        <Loader
          loading={isLoading}
          title={t("initial.loader.title")}
          message={t("sepaMandateCallback.loading.message")}
        />
        {!isEmpty(signatureLink) && (
          <>
            <div className="mt-4">
              <iframe
                src={signatureLink}
                title="SEPA Mandate Signature"
                width="100%"
                height="400px"
                style={{ border: "none" }}
              />
            </div>
            <Back message={t("back.label")} />
          </>
        )}
      </>
    );
  };

  return (
    <Layout>
      <div className="az-title">{t("sepaMandate.sign.title")}</div>
      {renderContent()}
    </Layout>
  );
};

export default SepaMandate;
